<template>
  <div class="box box_v" style="height: 100%">
    <div class="mini-header-wrapper">
      <div class="left">
        <div class="iconfont icon-fanhui2" @click="goback"></div>
      </div>
      <div class="mini-header">{{title}}</div>
    </div>
    <div class="item-wrapper box box_f1">
      <Card v-if="type == 'service'" style="width: 100%">
        <div class="service-con">
          <div class="box">
            <div class="example">示例</div>
            <div class="box_f1 service-r">
              <img src="../../assets/images/apps/ex1.png" alt />
              <div class="shuoming">说明: 社区一公里生活圈，方便居民了解社区周边商家服务</div>
              <div class="service-radio">
                是否在首页展示该模块
                <RadioGroup v-model="service" style="margin-top: -5px;margin-left: 10px;color: #999" @on-change="showChange">
                  <Radio label="是"></Radio>
                  <Radio label="否"></Radio>
                </RadioGroup>
              </div>
            </div>
          </div>
          <div class="box service-nav" >
            <div style="align-self: flex-end">数据维护</div>
            <Button type="primary" @click="addService">新增</Button>
          </div>

          <div class="table-data" style="margin-top: 15px">
            <Table border :columns="settingColumn" :data="settingData" :loading="isTableLoading"></Table>
          </div>
        </div>
        <Spin fix v-if="loading"></Spin>
      </Card>
      <Card v-if="type == 'setting'" style="width: 100%;margin-right: 20px;margin-bottom: 20px">
        <div class="setting-con">
          <div class="setting-t">样式选择</div>
          <div class="setting-radio">
            <RadioGroup v-model="setting" style="display: flex;width: 60%" @on-change="radioChange">
              <div class="radio1 box_f1">
                <img src="../../assets/images/apps/ex3.png" alt style="display: block"/>
                <Radio label="样式一" style="margin-top: 15px;margin-left: 28%"></Radio>
              </div>
              <div class="radio1 box_f1">
                <img src="../../assets/images/apps/ex2.png" alt style="display: block"/>
                <Radio label="样式二" style="margin-top: 15px;margin-left: 28%"></Radio>
              </div>
            </RadioGroup>
          </div>
          <div class="setting-t" style="margin-top: 30px">数据维护</div>
          <div class="table-data" style="margin-top: 15px">
            <Table border :columns="settingColumn" :data="settingData" :loading="isTableLoading"></Table>
          </div>
        </div>
        <Spin fix v-if="loading"></Spin>
      </Card>
    </div>
  </div>
</template>

<script>
var that
export default {
  data() {
    return {
      title: "",
      type: "",
      service: "是",
      setting: "样式一",
      settingColumn: [],
      settingColumnService : [
        {
          title: "名称",
          key: "title"
        },
        {
          title: "企业数",
          key: 'num'
        },
        {
          title: "操作",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                  },
                  on: {
                    click: () => {
                      // that.toDetail(params.index)
                      // console.log(params.index)
                      that.setService(params.index)
                    }
                  }
                },
                "[查看]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px",
                    display: params.index == 0 ? 'none' : ''
                  },
                  on: {
                    click: () => {
                      // that.toNewVote(params.index)
                      that.sortJia(params.index)
                    }
                  }
                },
                "[上移]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px",
                    display: params.index == that.settingData.length - 1 ? 'none' : ''
                  },
                  on: {
                    click: () => {
                      console.log(params.index);
                      // that.showShareModal(params.index)
                      that.sortJian(params.index)
                    }
                  }
                },
                "[下移]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px",
                  },
                  on: {
                    click: () => {
                      that.delSerivce(params.index)
                    }
                  }
                },
                "[删除]"
              )
            ]);
          }
        },
      ],
      settingColumn1: [
        {
          title: "标题",
          key: "title"
        },
        {
          title: "副标题",
          key: 'remark'
        },
        {
          title: "关联模块",
          key: "model"
        },
        {
          title: "是否展示",
          key: "isShow"
        },
        {
          title: "操作",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                  },
                  on: {
                    click: () => {
                      // that.toDetail(params.index)
                      // console.log(params.index)
                      that.setModel(params.index)
                    }
                  }
                },
                "[编辑]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px",
                    display: params.index == 0 || params.row.isShow == '否' ? 'none' : ''
                  },
                  on: {
                    click: () => {
                      that.sortJia(params.index)
                    }
                  }
                },
                "[上移]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px",
                    display: params.index == that.settingData.length - 1 || params.row.isShow == '否' ? 'none' : ''
                  },
                  on: {
                    click: () => {
                      that.sortJian(params.index)
                    }
                  }
                },
                "[下移]"
              )
            ]);
          }
        },
      ],
      settingColumn2: [
        {
          title: "标题",
          key: "title"
        },
        {
          title: "关联模块",
          key: "model"
        },
        {
          title: "是否展示",
          key: "isShow"
        },
        {
          title: "操作",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                  },
                  on: {
                    click: () => {
                      // that.toDetail(params.index)
                      // console.log(params.index)
                      that.setModel(params.index)
                    }
                  }
                },
                "[编辑]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px",
                    display: params.index == 0 || params.row.isShow == '否' ? 'none' : ''
                  },
                  on: {
                    click: () => {
                      // that.toNewVote(params.index)
                      that.sortJia(params.index)
                    }
                  }
                },
                "[上移]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px",
                    display: params.index == that.settingData.length - 1 || params.row.isShow == '否' ? 'none' : ''
                  },
                  on: {
                    click: () => {
                      console.log(params.index);
                      // that.showShareModal(params.index)
                      that.sortJian(params.index)
                    }
                  }
                },
                "[下移]"
              )
            ]);
          }
        },
      ],
      settingData: [],
      isTableLoading: false,
      loading: false
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    setModel(index){
      this.$router.push({name: 'modelSet', query: {id:this.settingData[index].id, moduleId: this.settingData[index].moduleId}})
    },
    setService (index) {
      this.$router.push({name: 'serviceSet', query: {id:this.settingData[index].id}})
    },
    getSettingList() {
      var url = this.urlobj.getMstSetting+'?appType='+this.$store.state.apptype
      this.isTableLoading = true
      this.$get(url).then(res => {
        console.log(res)
        var col = {
          title: '副标题',
          key: 'remark'
        }
        if(!res.rows[0]){
          console.log('wu')
          this.$Message.warning('未获取到数据')
          this.isTableLoading = false
          return
        }
        var mst = res.rows[0][this.$store.state.apptype]
        this.setting = res.newPrimaryKeys.setting_style == 2 ? '样式一' : '样式二'
        var list = mst.map(item => {
          return {
            title: item.moduleName,
            remark: item.subTitle ? item.subTitle : '',
            model: item.linkModuleName,
            isShow: item.isShow == 1 ? '是' : '否',
            id: item.id,
            moduleId: item.moduleId,
            sortNo: item.sortNo
          }
        })
        // this.settingColumn.splice(1, 1)
        if(this.setting == '样式一') {
          this.settingColumn = this.settingColumn1
        }else if(this.setting == '样式二') {
          this.settingColumn = this.settingColumn2
        }
        this.settingData = list
        console.log(this.settingData)
        this.isTableLoading = false
      })
    },
    radioChange(val) {
      this.loading = true
      this.setting = val
      var url = this.urlobj.setStyle
      var data = {
        id: this.$route.query.id,
        communityId: this.$store.state.streetorcommunityid,
        type: 'setting',
        style: val == '样式一' ? 2 : 1,
        appType: this.$store.state.apptype,
      }
      console.log(data)
      this.$post(url, data).then(res => {
        if(!res.isSucceed){
          this.$Message.warning(res.message)
          this.loading = false
          return
        }
        this.getSettingList()
        this.loading = false
      })

    },
    showChange(val) {
      this.loading = true
      var url = this.urlobj.setStyle
      var data = {
        id: this.$route.query.id,
        communityId: this.$store.state.streetorcommunityid,
        type: 'service',
        isShow: val == '是' ? 1 : 0
      }
      this.$post(url, data).then(res => {
        if(!res.isSucceed){
          this.$Message.warning(res.message)
          this.loading  = false
          return
        }
        this.$Message.success('操作成功')
        this.loading = false
      })
    },
    //上移
    sortJia(index) {
      var arrItem = {}
      var arrItem1 = this.settingData[index]
      var arrItem2 = this.settingData[index - 1]
      arrItem = arrItem2
      this.settingData[index] = arrItem
      this.settingData[index - 1] = arrItem1
      var url = this.urlobj.sortList
      this.isTableLoading = true
      if (this.type == 'setting') {
        var data = this.settingData.map((item, index) => {
          return {
            id: item.id,
            sortNo: index
          }
        })
        this.$post(url, data).then(res => {
          this.isTableLoading = false
          this.$Message.success('操作成功')
          this.getSettingList()
        }).catch(e => {
          this.isTableLoading = false
        })
      }else {
        var data = this.settingData.map((item, index) => {
          return item.id
        })
        this.$post(this.urlobj.companyTypeSort, data).then(res => {
          this.isTableLoading = false
          this.$Message.success('操作成功')
          this.getCompayType()
        }).catch(e => {
          this.isTableLoading = false
        })
      }
    },
    //下移
    sortJian(index) {
      var arrItem = {}
      var arrItem1 = this.settingData[index]
      var arrItem2 = this.settingData[index + 1]
      arrItem = arrItem2
      this.settingData[index] = arrItem
      this.settingData[index + 1] = arrItem1
      this.isTableLoading = true
      if (this.type == 'setting') {
        var data = this.settingData.map((item, index) => {
          return {
            id: item.id,
            sortNo: index
          }
        })
        this.$post(this.urlobj.sortList, data).then(res => {
          this.isTableLoading = false
          this.$Message.success('操作成功')
          this.getSettingList()
        }).catch(e => {
          this.isTableLoading = false
        })
      }else {
        var data = this.settingData.map((item, index) => {
          return item.id
        })
        this.$post(this.urlobj.companyTypeSort, data).then(res => {
          this.isTableLoading = false
          this.$Message.success('操作成功')
          this.getCompayType()
        }).catch(e => {
          this.isTableLoading = false
        })
      }
    },
    delSerivce (index) {
      var url = this.urlobj.delCompanyType(this.settingData[index].id)
      this.$delete(url).then(res => {
        this.$Message.success('删除成功')
        this.getCompayType()
      }).catch(e => {
      })
    },
    getCompayType () {
      var url = this.urlobj.getCompayType
      this.$post(url,{
        pageNum :1 ,//当前页码--不传查询全部,
        pageSize : 99,//每页大小--不传查询全部
        communityId : this.$store.state.streetorcommunityid,//社区ID，不传为当前登录社区,
        companyType : 'service',//type--企业类型，service--服务类型
      }).then(res => {
        this.settingData  = res.rows.map(item => {
          return {
            title:item.title,
            num:item.companyCount,
            id:item.id
          }
        })
      })
    },
    addService () {
      this.$router.push({name:'serviceSet'})
    }
  },
  mounted() {
    switch (this.$route.query.type) {
      case "service":
        this.title = "生活服务展示";
        this.type = this.$route.query.type;
        this.service = this.$route.query.isShow == 1 ? '是' : '否'
        this.settingColumn = this.settingColumnService
        this.getCompayType()
        break;
      case "setting":
        this.title = "功能模块设置";
        this.type = this.$route.query.type;
        this.getSettingList()
        break;
    }
  },
  created() {
    that = this
  },
};
</script>

<style lang="less" scoped>
.left {
  position: absolute;
  left: 20px;
  font-size: 22px;
  .iconfont {
    font-size: 26px;
    color: #999;
  }
}
.mini-header-wrapper {
  display: flex;
  /*height: 30px;*/
  line-height: 30px;
  padding: 30px 0;
  justify-content: center;
  position: relative;
}
.mini-header {
  font-size: 25px;
  text-align: center;
}
.item-wrapper {
  padding: 0 20px 20px;
}
.example {
  font-size: 16px;
  margin-right: 20px;
}
.service-r {
  font-size: 14px;
}
.shuoming {
  margin-top: 20px;
  color: #999;
}
.service-radio {
  margin-top: 20px;
}
.setting-radio {
  margin-top: 20px;
}
  .service-nav{
    margin: 30px 0 20px;
    justify-content: space-between;
    button{
      height: 30px;
      width: 60px;
      line-height: 13px;
    }
  }
</style>
